import { Box, Grid, Card, useTheme, CircularProgress, Typography } from "@mui/material";
import VideoPlayer from "../components/videoplayer";
import CourseCurriculum from "../components/courseCurricullum";
import CourseTabs from "../components/CourseTabs";
import { useContext, useEffect, useRef, useState } from "react";
import { getCourseById } from "../api/courseAPI";
import AssessmentPlayer from "../components/Assessment";
import { useLocation, useParams } from "react-router-dom";
import { AuthContext } from "../theme/AuthContext";
import { markVideoCompleted, initializeCourseProgress, getCourseProgress } from "../api/progressAPI";

export default function CoursePage() {
  const theme = useTheme();
  const { courseId } = useParams();
  const auth = useContext(AuthContext);
  const completedRef = useRef(new Set());
  const location = useLocation();
  console.log("Location state:", location?.state);
  const courseFromState = location.state?.course;
  console.log(courseFromState)

  const userId = auth.user?.username;
  console.log("Authenticated user:", auth.user.username);

  console.log("Course ID from params:", courseId);

  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeLesson, setActiveLesson] = useState(null);
  const [modules, setModules] = useState([]);
  const [showAssessment, setShowAssessment] = useState(false);
  const [assessmentCompleted, setAssessmentCompleted] = useState(false);
  const [videosProgress, setVideosProgress] = useState([]);
  console.log("Course data in CoursePage:", course?.courseData);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const res = await getCourseById(courseId);

        console.log("Course response:", res);

        const courseData = res.data.courseData;

        setModules(courseData);
        setCourse(res.data);

        // Get all videos
        const videoIds = getAllVideoIds(courseData);

        console.log(
          "All course video IDs:",
          videoIds
        );

        if (videoIds.length > 0) {
          try {
            // Initialize/sync progress
            await initializeCourseProgress({
              userId,
              courseId,
              videoIds,
            });

            // Get existing progress
            const progressRes = await getCourseProgress({
              userId,
              courseId,
            });

            console.log(
              "Course progress response:",
              progressRes
            );

            const progress =
              progressRes.data?.data?.videosProgress || [];

            setVideosProgress(progress);

            console.log(
              "Videos progress:",
              progress
            );

            // Find first incomplete video
            const resumeLesson = getResumeLesson(
              courseData,
              progress
            );

            console.log("Resume lesson:", resumeLesson);

            if (resumeLesson) {
              setActiveLesson(resumeLesson);
            } else {
              // Course completely completed
              const firstVideo =
                courseData[0]?.topics?.[0]?.subTopics?.[0];

              if (firstVideo?.video) {
                setActiveLesson(firstVideo);
              }
            }

          } catch (progressError) {
            console.error(
              "Failed to load course progress:",
              progressError
            );
          }
        }

      } catch (error) {
        console.error(
          "Failed to load course:",
          error
        );

      } finally {
        setLoading(false);
      }
    };

    if (userId && courseId) {
      fetchCourse();
    }

  }, [courseId, userId]);



  const getAllVideoIds = (courseData = []) => {
    const videoIds = [];

    courseData.forEach((module) => {
      module?.topics?.forEach((topic) => {
        topic?.subTopics?.forEach((subTopic) => {
          if (subTopic?.video) {
            videoIds.push(subTopic.video);
          }
        });
      });
    });

    return [...new Set(videoIds)];
  };

  const getResumeLesson = (courseData = [], videosProgress = []) => {
    // Create lookup:
    // videoId -> completed
    const progressMap = new Map();

    videosProgress.forEach((item) => {
      if (item?.videoId) {
        progressMap.set(
          item.videoId,
          Number(item.completed)
        );
      }
    });

    console.log("Progress Map:", progressMap);

    // Walk through COURSE order
    for (const module of courseData) {
      for (const topic of module?.topics || []) {
        for (const subTopic of topic?.subTopics || []) {

          // Ignore things that don't have a video
          if (!subTopic?.video) {
            continue;
          }

          const videoId = subTopic.video;
          const completed = progressMap.get(videoId);

          console.log(
            "Checking video:",
            videoId,
            subTopic.title,
            "completed:",
            completed
          );

          // First video that isn't completed
          if (completed !== 1) {
            return subTopic;
          }
        }
      }
    }

    // Everything is completed
    return null;
  };



  function getNextLesson(modules, currentLessonId) {
    console.log("Finding next lesson after:", currentLessonId);
    for (let m = 0; m < modules.length; m++) {
      const module = modules[m];

      for (let t = 0; t < module.topics.length; t++) {
        const topic = module.topics[t];

        for (let s = 0; s < topic.subTopics.length; s++) {
          const sub = topic.subTopics[s];

          //  FOUND CURRENT LESSON
          if (sub.id === currentLessonId) {
            // 1️ Next subTopic
            if (topic.subTopics[s + 1]) {
              return topic.subTopics[s + 1];
            }

            // 2️ First subTopic of next topic
            if (module.topics[t + 1]?.subTopics?.length) {
              return module.topics[t + 1].subTopics[0];
            }

            // 3️ First subTopic of next module
            if (modules[m + 1]?.topics?.[0]?.subTopics?.length) {
              return modules[m + 1].topics[0].subTopics[0];
            }

            // 4️ End of course
            return null;
          }
        }
      }
    }

    return null;
  }

  const hasValidAssessment = (assessment) => {
    if (!assessment?.questions?.length) return false;

    return assessment.questions.some((q) => {
      const hasQuestion =
        q.question?.html?.trim() ||
        q.question?.imageUrl ||
        q.question?.pdfUrl ||
        q.question?.attachmentUrl;

      const hasOption = q.options?.some(
        (opt) =>
          opt.html?.trim() ||
          opt.imageUrl ||
          opt.attachmentUrl
      );

      return hasQuestion && hasOption;
    });
  };


  const handleVideoEnd = async () => {
    if (!activeLesson?.video || !userId) return;

    const videoId = activeLesson.video;

    //  update progress only once
    if (!completedRef.current.has(videoId)) {
      try {
        await markVideoCompleted({
          userId,
          courseId,
          videoId,
        });
        completedRef.current.add(videoId);
      } catch (err) {
        console.error("Progress update failed", err);
      }
    }

    // show assessment of current lesson (if any)
    if (hasValidAssessment(activeLesson.assessment)) {
      setShowAssessment(true);
      return;
    }

    const next = getNextLesson(modules, activeLesson.id);

    if (!next) {
      alert(" Course completed!");
      return;
    }

    if (next.video) {
      setShowAssessment(false);
      setActiveLesson(next);
    }
  };


  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!course) {
    return <Box sx={{ p: 3 }}>Course not found</Box>;
  }

  return (
    <Box sx={{ p: 3, backgroundColor: theme.palette.background.default, minHeight: "100vh" }}>
      <Grid container spacing={3}>

        {/* LEFT → Video + Tabs */}
        <Grid size={{ xs: 12, lg: 8 }}>
          <Card sx={{ p: 2, mb: 3 }}>
            {activeLesson && (
              <Box sx={{ mb: 1 }}>
                <Typography
                  fontSize={18}
                  fontWeight={500}
                  color={theme.palette.text.primary}
                >
                  {activeLesson.title}
                </Typography>
              </Box>
            )}

            {activeLesson && !showAssessment && activeLesson.video && (
              <VideoPlayer
                key={activeLesson.video}
                videoId={activeLesson.video}
                onEnded={handleVideoEnd}
              />
            )}

            {activeLesson &&
              showAssessment &&
              hasValidAssessment(activeLesson.assessment) && (
                <AssessmentPlayer
                  assessment={activeLesson.assessment}
                  onCorrect={async () => {
                    if (!userId) return;

                    const videoId = activeLesson.video;

                    if (videoId && !completedRef.current.has(videoId)) {
                      try {
                        await markVideoCompleted({
                          userId,
                          courseId,
                          videoId,
                        });
                        completedRef.current.add(videoId);
                      } catch (err) {
                        console.error("Progress update failed", err);
                      }
                    }

                    const next = getNextLesson(modules, activeLesson.id);

                    if (!next) {
                      alert(" Course completed!");
                      return;
                    }

                    if (!next.video) return;

                    setShowAssessment(false);
                    setActiveLesson(next);
                  }}
                />
              )}

          </Card>
          {/* Tabs Section */}
          <CourseTabs metadata={course?.courseData} data={location?.state} />
        </Grid>

        {/* RIGHT → Curriculum */}
        <Grid size={{ xs: 12, lg: 4 }}>
          <CourseCurriculum
            modules={course.courseData}
            activeLessonId={activeLesson?.id}

            onLessonSelect={(lesson) => {
              setShowAssessment(false);
              setAssessmentCompleted(false);
              setActiveLesson(lesson);
            }}

            onAssessmentSelect={(lesson) => {
              setActiveLesson(lesson);
              setShowAssessment(true);
              setAssessmentCompleted(false);
            }}
          />

        </Grid>

      </Grid>
    </Box>
  );
}
